import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, PropsWithChildren, useEffect, useMemo } from 'react';
import { NotificationManagerContext } from '../../context/NotificationManagerContext';
import { prepareProps } from '../../utils/propUtils';
import { NotificationManager } from '../classes/NotificationManager/NotificationManager';
export type NotificationManagerProviderProps = PropsWithChildren<Record<never, never>>;
export const NotificationManagerProvider: FunctionComponent<NotificationManagerProviderProps> = React.memo(props => {
  const $ = _c(7);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    children
  } = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      notificationManager: new NotificationManager()
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const notificationManagerContextValue = t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => () => {
      notificationManagerContextValue.notificationManager.destroy();
    };
    t3 = [notificationManagerContextValue];
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== children) {
    t4 = <NotificationManagerContext.Provider value={notificationManagerContextValue}>{children}</NotificationManagerContext.Provider>;
    $[5] = children;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
});